import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@tanstack/react-router'
import { Dashboard } from '@/features/dashboard'
import { getDefaultHomeForRole } from '@/lib/auth-redirect'
import { useAuthStore } from '@/stores/auth-store'

export const Route = createFileRoute('/_authenticated/')({
  component: Dashboard,
  beforeLoad: () => {
    const user = useAuthStore.getState().auth.user
    const role = user?.role || user?.type

    // Per requirement: `/` is admin-only.
    if (role === 'admin') return

    if (role === 'reseller') {
      throw redirect({ to: '/reseller', replace: true })
    }

    if (role === 'vendor_panel' || role === 'buyer_panel') return

    if (role === 'customer') {
      throw redirect({ to: '/customer', replace: true })
    }

    if (!role) {
      const token = useAuthStore.getState().auth.getEffectiveAccessToken()
      if (!token) {
        throw redirect({ to: '/sign-in', replace: true })
      }
      return
    }

    throw redirect({ to: getDefaultHomeForRole(role), replace: true })
  },
})
